import api from '../../api.es6';
import axios from 'axios';
export default {
    emits: ['saveSuccess'],
	methods: {
        getDataUrl(getPageName, savedDrugs){
            let getUrlData = {
				'save' :{
					url : '/api/svcgateway/v2/papix/papi.svc/data/savedcontent/coll',
					popupType : 'save',
					delete : 0,
					id : '',
				},
				'delete' :{
					url : '/api/svcgateway/v2/papix/papi.svc/update/savedcontent',
					popupType : 'delete',
					delete : 1,
					id : savedDrugs['_id'],
				}
			}
            return (getUrlData && getUrlData[getPageName]) ? getUrlData[getPageName] : null
        },
		checkSaved(access_token, contentData){
			const query = '/api/svcgateway/v2/papix/papi.svc/data/savedcontent/query?count=999';
			let searchapi = this.checkUrl('www',query);
			const body = '$filter=deleted eq 0';
			return api.getUserHeaders('', access_token).then(headers => axios.post(`${searchapi}`, body, headers)).then((response) => {
				if (response && response.data && response.data.code == 1) {
					let savedList = response.data.data
					if(savedList){
						savedList = savedList.find(list=>list.type==contentData.type && (list.item_id==contentData.item_id));
                        return {type: contentData.type, data : (savedList && Object.keys(savedList).length>0) ? savedList : null}
					}
					else{
						return {type: contentData.type, data : null}
					}
				}
			}).catch(() => {
				return {type: contentData.type, data : null}
			});
		},

		saveDrugsData(authToken, contentData, pageName, savedDrugs, omnitureCall=true){
            let apiUrl = this.getDataUrl(pageName, savedDrugs)
            if(apiUrl){
                let getData = [{
                    "type": contentData.type,
                    "deleted": apiUrl.delete,
                    "_id":  apiUrl.id,
                    "item_id": "",
                    "title": "",
                    "summary": "",
                    "thumbnailURLString": "",
                    "secondaryID": "",
                    "CreatedDate":new Date().toISOString(),
                    "UpdateDate":new Date().toISOString(),
                    "RxData": null,
                    ...contentData
                }]
                getData = JSON.stringify(getData);
                let query = apiUrl.url;
                let searchapi = this.checkUrl('www',query);
                if(omnitureCall){
                    this.$vwmdPageLink({ moduleName: `reg-email-ver_refresh` });
                }
                return api.getUserHeaders('', authToken).then(headers => {
                    let axHeader = {headers : {...headers.headers, ...{'Content-Type':'text/plain'}}}
                    return axios.post(`${searchapi}`, getData, axHeader, {credentials: 'include'})
                }).then((response) => {
                    if(response.data && response.data.code==1){
                        return { type:'saved', data : response.data.data , popupType:apiUrl.popupType}
                    }
                    return null
                }).catch(() => {
                    return { type:'saved', data : null}
                });
            }
            else{
                return { type:'saved', data : null}
            }
		},

        async saveAfterAuth(authToken, pageName, contentData, savedDrugs){
            let checkData = await this.checkSaved(authToken, contentData);
            if(checkData.data==null){
                let getSavedData = await this.saveDrugsData(authToken, contentData, pageName, savedDrugs, false);
                if(getSavedData && getSavedData.data){
                    return { type:'saved', data : getSavedData}
                }
                else{
                    return { type:'saved', data : null}
                }
            }
            this.$emit('saveSuccess', true);
            return { type: contentData.type, data : checkData}
        }
    }
}